import { createSlice } from '@reduxjs/toolkit';
import { addNewCustomer, editCustomer, getAllCustomers, getCustomerById } from './customersService';

const initialState = {
  allCustomers: {
    isCustomersLoading: null,
    isCustomersSuccess: null,
    customersMessage: null,
    pageCount: 0,
    customers: [],
  },
  newCustomer: {
    isCustomerCreating: null,
    isCustomerCreated: null,
    customerCreationMsg: null,
  },

  editedCustomer: {
    isEditingCustomer: null,
    isCustomerEdited: null,
    customerEditedMsg: null
  },
  customer: {
    isCustomerLoading: null,
    isCustomerSuccess: null,
    customer: null,
  },
};

const customersSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllCustomers.pending, (state) => {
        state.allCustomers = {
          ...initialState.allCustomers, // Reset to initial state
          isCustomersLoading: true,
          customersMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllCustomers.rejected, (state, action) => {
        state.allCustomers = {
          ...initialState.allCustomers,
          isCustomersLoading: false,
          isCustomersSuccess: false,
          customersMessage: action.payload || 'Error occurred while fetching customers',
        };
      })

      // FULFILLED
      .addCase(getAllCustomers.fulfilled, (state, action) => {
        state.allCustomers = {
          ...initialState.allCustomers,
          isCustomersLoading: false,
          isCustomersSuccess: true,
          pageCount: action.payload.pageCount || 0,
          customers: action.payload.data || [],
        };
      });

    //Customer creating
    builder
      .addCase(addNewCustomer.pending, (state) => {
        state.newCustomer = {
          ...initialState.newCustomer, // Reset to initial state
          isCustomerCreating: true,
          customerCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewCustomer.rejected, (state, action) => {
        state.newCustomer = {
          ...initialState.newCustomer,
          isCustomerCreating: false,
          isCustomerCreated: false,
          customerCreationMsg: action.payload || 'Error occurred while creating the customer.',
        };
      })

      // FULFILLED
      .addCase(addNewCustomer.fulfilled, (state, action) => {
        state.newCustomer = {
          ...initialState.newCustomer,
          isCustomerCreating: false,
          isCustomerCreated: true,
          customerCreationMsg: action.payload || 'Successfully created the customer.',
        };
      });

    //Customer editing
    builder
      .addCase(editCustomer.pending, (state) => {
        state.editedCustomer = {
          ...initialState.editedCustomer, // Reset to initial state
          isEditingCustomer: true,
          customerEditedMsg: 'Loading',
        };
      })

      .addCase(editCustomer.rejected, (state, action) => {
        state.editedCustomer = {
          ...initialState.editedCustomer, // Reset to initial state
          isEditingCustomer: false,
          isCustomerEdited: false,
          customerEditedMsg: action.payload || 'Error occurred while editing the customer.',
        };
      })

      .addCase(editCustomer.fulfilled, (state, action) => {
        state.editedCustomer = {
          ...initialState.editedCustomer, // Reset to initial state
          isEditingCustomer: false,
          isCustomerEdited: true,
          customerEditedMsg: action.payload || 'Successfully edited the customer.',
        };
      });

    //Customer get
    builder
      .addCase(getCustomerById.pending, (state) => {
        state.customer = {
          ...initialState.customer,
          isCustomerLoading: true,
        };
      })

      .addCase(getCustomerById.rejected, (state, action) => {
        state.customer = {
          ...initialState.customer,
          isCustomerLoading: false,
          isCustomerSuccess: false,
        };
      })

      .addCase(getCustomerById.fulfilled, (state, action) => {
        state.customer = {
          ...initialState.customer,
          isCustomerLoading: false,
          isCustomerSuccess: true,
          customer: action.payload,
        };
      });
  },
});

export default customersSlice.reducer;
